import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { BusinesLogicService } from "../../services/business-logic.service";
import { DataService } from "../../services/data.service";
import { ModalHelper } from "../../components/modal/modal.helper";
import { UtilsService } from "../../services/utils.service";
import { CallComponent } from "../call/call.component";
import { Subscription } from "rxjs/Subscription";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BusinessEventService } from "../../services/business-event.service";
import { TurnService } from "../../services/turn.service";

@Component({
  selector: "app-status",
  templateUrl: "./status.component.html",
  styleUrls: ["./status.component.css"],
})
export class StatusComponent implements OnInit {
  private destroy$ = new Subject();

  @Output() websocketError: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() withButton: boolean = false;
  @ViewChild(CallComponent) callComponent: CallComponent;

  public changeDeskStatusEnabled = true;

  public queueResume: any = [];
  public atypeResume: any = [];
  public socketRetries: number = 0;
  public ioConnection: any;
  private subscriptionClose: Subscription;
  private subscriptionOpen: Subscription;
  public totalInOffice: number = 0;
  public loadingSocket: boolean = false;
  constructor(
    private _blogic: BusinesLogicService,
    public _data: DataService,
    private _utils: UtilsService,
    private _modal: ModalHelper,
    private _turn: TurnService,
    private _bevent: BusinessEventService,
  ) {}

  ngOnInit() {

    if (!this.withButton) this.initIoConnection();
    this.getAtypeStatus();
    this.getQueueStatus();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Initialize SocketConnection
  private initIoConnection(): void {
    if (!this.loadingSocket) {
      this.loadingSocket = true;
      if (this.socketRetries != null) this.socketRetries++;

      if (this.subscriptionClose != null) this.subscriptionClose.unsubscribe();
      if (this.subscriptionOpen != null) this.subscriptionOpen.unsubscribe();
      if (this.ioConnection != null) this.ioConnection.unsubscribe();

      this.ioConnection = this._bevent
        .onMessage()
        .subscribe((response: any) => {
          if (response["eventhook"] == "turninfo") {
            this.changeDeskStatus();

            var dateReg = /^\d{4}[./-]\d{2}[./-]\d{2} \d{2}[.:]\d{2}[.:]\d{2}$/;
            // Actualizamos listado de colas
            let qResponse = response["message"]["qinfo"];
            for (let i = 0; i < qResponse.length; i++) {
              if (
                qResponse[i].initdatetime != null &&
                !(typeof qResponse[i].initdatetime == "number") &&
                qResponse[i].initdatetime.match(dateReg)
              ) {
                qResponse[i].initdatetime = this._utils.getWaitTime(
                  qResponse[i].initdatetime,
                  null,
                  false,
                  false
                );
              } else {
                qResponse[i].initdatetime = 0;
              }
            }
            this.queueResume = JSON.parse(JSON.stringify(qResponse));
            this.countTotalInWait();

            // Actualizamos listado de tipos de atención
            var kinds = this._data.session["atypes"];
            var availableKinds = [];
            kinds.forEach((e) => {
              availableKinds.push(e.id);
            });

            let kResponse = response["message"]["kinfo"];
            var parseResponse = [];
            kResponse.forEach((e) => {
              if (availableKinds.indexOf(e.id) != -1) {
                if (
                  e.initdatetime != null &&
                  !(typeof e.initdatetime == "number") &&
                  e.initdatetime.match(dateReg)
                ) {
                  e.initdatetime = this._utils.getWaitTime(
                    e.initdatetime,
                    null,
                    false,
                    false
                  );
                } else {
                  e.initdatetime = 0;
                }
                parseResponse.push(e);
              }
            });

            if (parseResponse.length != 0) {
              this.atypeResume = JSON.parse(JSON.stringify(parseResponse));
            } else {
              this.atypeResume = [];
            }
          }
      });

      this.subscriptionOpen = this._bevent
        .onOpen()
        .subscribe((response: any) => {
          this.loadingSocket = false;
        });

      this.subscriptionClose = this._bevent
        .onClose()
        .subscribe((response: any) => {
          this.loadingSocket = false;
          this.initIoConnection();
        });
    }
  }

  /* Get queue status */
  public parseQueueStatus(response): void {
    for (let i = 0; i < response.length; i++) {
      response[i].initdatetime = this._utils.getWaitTime(
        response[i].initdatetime,
        null,
        false,
        false
      );
    }

    this.queueResume = JSON.parse(JSON.stringify(response));
    this.countTotalInWait();
  }

  /* Get atypes status */
  public parseAtypeStatus(response): void {
    for (let i = 0; i < response.length; i++) {
      response[i].initdatetime = this._utils.getWaitTime(
        response[i].initdatetime,
        null,
        false,
        false
      );
    }
    if (response.length != 0) {
      this.atypeResume = JSON.parse(JSON.stringify(response));
    }
  }

  /* Get queue status */
  public getQueueStatus(): void {
    this._blogic
      .getQueueInfo()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        for (let i = 0; i < response.length; i++) {
          response[i].initdatetime = this._utils.getWaitTime(
            response[i].initdatetime,
            null,
            false,
            false
          );
        }
        this.queueResume = JSON.parse(JSON.stringify(response));
        this.countTotalInWait();
      });
  }

  public countTotalInWait(): void {
    var totalInOffice: number = 0;

    for (let i = 0; i < this.queueResume.length; i++) {
      totalInOffice = totalInOffice + this.queueResume[i].size;
    }

    this.totalInOffice = totalInOffice;
  }

  /* Get queue status */
  public getAtypeStatus(): void {
    var kinds = this._data.session["atypes"];
    var availableKinds = [];
    kinds.forEach((e) => {
      availableKinds.push(e.id);
    });

    this._blogic
      .getKindInfo()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        var parseResponse = [];
        response.forEach((e) => {
          if (availableKinds.indexOf(e.id) != -1) {
            e.initdatetime = this._utils.getWaitTime(
              e.initdatetime,
              null,
              false,
              false
            );
            parseResponse.push(e);
          }
        });

        if (parseResponse.length != 0) {
          this.atypeResume = JSON.parse(JSON.stringify(parseResponse));
        } else {
          this.atypeResume = [];
        }
      });
  }

  /* Parse atype list using the desk id as key of array */
  private _parseAtypes(atypes: any[]): any {
    var filterArray: any[] = [];
    for (let i = 0; i < this._data.session["atypes"].length; i++) {
      for (let e = 0; e < atypes.length; e++) {
        if (this._data.session["atypes"][i][0] == atypes[e].name) {
          filterArray.push(atypes[e]);
        }
      }
    }

    return filterArray;
  }

  /* Open status modal */
  public openStatusModal(): void {
    this._modal.show("statusModal");
  }

  /* Call queue from a specific atype */
  public callFromAtype(id: number): void {
    let params: object = {
      filter: "queue",
      desk_id: this._data.session["desk"],
      status: "A",
      selschema: "K",
      selid: id,
      deskuser: this._data.session["username"],
      deskoperator: this._data.session["operator"],
    };

    this._blogic
      .deskNotify(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        let parse = response;
        if (parse["id"] == "-1") {
          this._data.turn = null;
        } else {
          this._data.turn = parse;
          this._data.lastCalls.unshift(response);
        }
      });
  }

  public callFromQueue(id: number): void {
    let params: object = {
      filter: "queue",
      desk_id: this._data.session["desk"],
      status: "A",
      selschema: "Q",
      selid: id,
      deskuser: this._data.session["username"],
      deskoperator: this._data.session["operator"],
    };

    this._blogic
      .deskNotify(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        let parse = response;
        if (parse["id"] == "-1") {
          this._data.turn = null;
        } else {
          this._data.turn = parse;
          this._data.lastCalls.unshift(response);
        }
      });
  }

  public showAlert(value) {
    this.socketRetries = null;
    this.subscriptionClose.unsubscribe();
    this.subscriptionOpen.unsubscribe();
    this.ioConnection.unsubscribe();

    this._bevent.close();

    this.websocketError.emit(true);
  }

  public changeDeskStatus() {
    if (
      this._data.turn == null ||
      (this._data.turn["id"] && this._data.turn["id"] == -1)
    ) {
      if (this.changeDeskStatusEnabled) {
        let params: object = {
          desk_id: this._data.session["desk"],
          status: "query",
        };
        this.changeDeskStatusEnabled = false;
        setTimeout(() => {
          this.changeDeskStatusEnabled = true;
        }, 1000);
        this._turn.startAutoSupervisor();
      }
    }
  }
}
